import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-available-screen',
  templateUrl: './mobile-available-screen.component.html',
  styleUrls: ['./mobile-available-screen.component.scss'],
})
export class MobileAvailableScreenComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
